const MESH_COMPRESSION = [
  { text: 'None', value: 'none' },
  { text: 'Draco', value: 'draco' },
  { text: 'Draco Lossy', value: 'dracoLossy' },
];

export const getMeshCompressionLabel = (mesh = '') => {
  return MESH_COMPRESSION.find((m) => m.value === mesh)?.text || 'Unknown';
};
